import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Layout from "../../Layouts";
import AdminContext from "../../Services/Admin";
import UsersIcon from "../../Assets/Icons/outline/profile-2user.svg";
import IncentiveIcon from "../../Assets/Icons/outline/money-recive.svg";
import UserAddIcon from "../../Assets/Icons/outline/user-cirlce-add.svg";
import Button from "../../Components/Button";
import { useNavigate, useParams } from "react-router-dom";
import Pagination from "../../Components/Pagination";
import GroupTable from "./Tab/GroupTable";
import Tab from "./Tab/Tab";
import GroupModal from "./Tab/GroupModal";
import { toast } from "react-toastify";
import MemberTable from "./Tab/MemberTable";
import MemberModal from "./Tab/MemberModal";
import Modal from "../../Components/Modal";
import IncentiveModal from "./Tab/IncentiveModal";
import IncentiveTable from "./Tab/IncentiveTable";
import { isSuperAdmin } from "../../utils/auth";

const schema = yup
	.object({
		name: yup.string().required(),
		email: yup.string().email(),
		status: yup.string().required(),
	})
	.required();

const schemaIncentive = yup
	.object({
		name: yup.string().required(),
		bonus: yup.number().required(),
	})
	.required();

function MasterPage(params) {
	const { loading, getAllMaster, addMaster, addMasterForm } = useContext(AdminContext);
	const [data, setData] = useState({});
	const [pagination, setPagination] = useState(1);
	const [search, setSearch] = useState("");
	const { tab } = useParams();
	const navigate = useNavigate();
	const [modal, setModal] = useState({
		show: false,
		id: "",
		type: "",
		data: {},
	});

	const [dataGroup, setDataGroup] = useState([]);
	const dataRoles = [
		{
			label: "Superadmin",
			value: "Superadmin",
		},
		{
			label: "Manager",
			value: "Manager",
		},
		{
			label: "Lead Designer",
			value: "Lead Designer",
		},
		{
			label: "Senior Designer",
			value: "Senior Designer",
		},
		{
			label: "Junior Designer",
			value: "Junior Designer",
		},
	];

	const defaultValues = {
		name: "",
		status: "",
	};

	const defaultValuesIncentive = {
		name: "",
		bonus: "",
	};

	const {
		register,
		handleSubmit,
		reset,
		control,
		watch,
		formState: { errors },
	} = useForm({
		resolver: yupResolver(schema),
	});

	const {
		register: registerIncentive,
		handleSubmit: handleSubmitIncentive,
		reset: resetIncentive,
		control: controlIncentive,
		watch: watchIncentive,
		formState: { errors: errorsIncentive },
	} = useForm({
		resolver: yupResolver(schemaIncentive),
	});

	const getData = async () => {
		const newData = await getAllMaster(`master/${tab}?page=${pagination}&search=${search}`);
		if (newData) {
			setData(newData);
		}
	};

	const getDataGroup = async () => {
		const newData = await getAllMaster(`master/group`);
		if (newData) {
			setDataGroup(newData?.data?.map((item) => ({ value: item?.id, label: item?.name })));
		}
	};

	const getDataIncentive = async () => {
		const newData = await getAllMaster(`master/incentive?page=${pagination}&search=${search}`);
		if (newData) {
			setData(newData);
		}
	};

	useEffect(() => {
		if (tab === "group" || tab === "member" || tab === "incentive") {
			if (tab === "incentive") {
				getDataIncentive();
				return;
			}
			if (tab === "member") {
				getDataGroup();
			}
			getData();
		}
	}, [pagination, search, tab]);

	const handleShow = (id, type, data) => setModal({ show: true, id: id, type: type, data: data });

	const handleClose = () => {
		setModal({ show: false, id: "", type: "", data: {} });
		reset(defaultValues);
		resetIncentive(defaultValuesIncentive);
	};

	const addAction = async (values) => {
		const formData = new FormData();

		if (tab === "incentive") {
			// handle incentive form data
			formData.append("name", values.name);
			formData.append("bonus", values.bonus);

			let response = await addMasterForm(`master/incentive/create`, formData);
			if (!response?.message) {
				getData();
				toast.success("Add Data Success");
				handleClose();
			}

			return;
		}

		// handle group/member form data
		formData.append("name", values.name);
		formData.append("status", values.status);
		if (tab === "member") {
			formData.append("email", values.email);
			formData.append("phone_number", values.phone_number);
			formData.append("password", values.password);
			formData.append("m_roles_id", values.m_roles_id);
			formData.append("m_groups_id", values.m_groups_id);
			formData.append("photo_file", values.photo_file[0]);
		}

		let response = await addMasterForm(`master/${tab}/create`, formData);
		if (!response?.message) {
			getData();
			toast.success("Add Data Success");
			handleClose();
		}
	};

	const updateAction = async (values) => {
		const formData = new FormData();
		if (tab === "incentive") {
			// handle incentive form data
			formData.append("name", values.name);
			formData.append("bonus", values.bonus);

			let response = await addMasterForm(`master/incentive/update/${modal?.data?.id}`, formData);
			if (!response?.message) {
				getData();
				toast.success("Update Data Success");
				handleClose();
			}
			return;
		}

		// handle group/member form data
		formData.append("name", values.name);
		formData.append("status", values.status);
		if (tab === "member") {
			formData.append("email", values.email);
			formData.append("phone_number", values.phone_number);
			formData.append("password", values.password);
			formData.append("m_roles_id", values.m_roles_id);
			formData.append("m_groups_id", values.m_groups_id);
			formData.append("photo_file", values.photo_file[0]);
		}
		let response = await addMasterForm(`master/${tab}/update/${modal?.data?.id}`, formData);
		if (!response?.message) {
			getData();
			toast.success("Update Data Success");
			handleClose();
		}
	};

	const deleteAction = async () => {
		const res = await addMaster(`master/${tab}/delete/${modal?.data?.id}`);
		if (!res?.err) {
			getData();
			toast.success("Delete Data Success");
			handleClose();
		}
	};

	const resetData = () => {
		setData({});
		setDataGroup({});
	};

	useEffect(() => {
		resetData();
		if (tab !== "group" && tab !== "member" && tab !== "incentive") {
			navigate("/dashboard");
		}
	}, [tab]);

	useEffect(() => {
		if (modal.type === "update" && modal.data) {
			const oldData = modal.data;
			let bodyRequest = {};

			if (tab === "incentive") {
				// handle incentive reset form data
				bodyRequest = {
					name: oldData?.name,
					bonus: oldData?.bonus,
				};
				resetIncentive(bodyRequest);
				return;
			}
			// handle group/member reset form data
			if (tab === "group") {
				bodyRequest = {
					name: oldData?.name,
					status: oldData?.status?.toString(),
				};
			} else {
				bodyRequest = {
					name: oldData?.name,
					email: oldData?.email,
					phone_number: oldData?.phone_number,
					m_roles_id: oldData?.roles?.[0]?.name,
					m_groups_id: oldData?.m_groups_id,
					status: oldData?.status?.toString(),
				};
			}
			reset(bodyRequest);
		}
	}, [modal.type]);

	const selectHandlerSubmit = tab === "incentive" ? handleSubmitIncentive : handleSubmit;

	const IconTab = tab === "incentive" ? IncentiveIcon : UsersIcon;

	return (
		<Layout title={tab} icon={IconTab}>
			<div className="flex items-center justify-between mb-10">
				<div className="grid">
					<div className="font-semibold">Add {tab}</div>
					<div className="font-light">Only people with permission to create {tab} can see this.</div>
				</div>
				<Button icon={UserAddIcon} onClick={() => handleShow(null, "add")} width="250px" className="text-xl py-3">
					Add {tab}
				</Button>
			</div>

			<Tab setPagination={setPagination} setSearch={setSearch} tab={tab} />

			<div className="relative overflow-x-auto">
				{tab === "incentive" && isSuperAdmin() && (
					<IncentiveTable data={data?.data} from={data?.from} handleShow={handleShow} />
				)}
				{tab === "member" && <MemberTable data={data?.data} from={data?.from} handleShow={handleShow} />}
				{tab === "group" && <GroupTable data={data?.data} from={data?.from} handleShow={handleShow} />}

				<Pagination data={data} pagination={pagination} setPagination={setPagination} />
			</div>

			<Modal
				icon={UserAddIcon}
				modal={modal}
				name={modal.type + " " + tab}
				handleClose={handleClose}
				submit={
					modal.type !== "delete" ? selectHandlerSubmit(modal.type === "add" ? addAction : updateAction) : deleteAction
				}
				loading={loading}
			>
				{tab === "group" && modal.type !== "delete" && <GroupModal register={register} errors={errors} />}
				{tab === "member" && modal.type !== "delete" && (
					<MemberModal
						register={register}
						errors={errors}
						control={control}
						dataGroup={dataGroup}
						dataRoles={dataRoles}
						watch={watch}
						image={modal?.data?.photo_file}
					/>
				)}
				{tab === "incentive" && modal.type !== "delete" && (
					<IncentiveModal
						register={registerIncentive}
						errors={errorsIncentive}
						control={controlIncentive}
						watch={watchIncentive}
					/>
				)}
				{modal.type === "delete" && <div className="text-xl">Are you sure you want to delete this item?</div>}
			</Modal>
		</Layout>
	);
}

export default MasterPage;
